var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 728,
    height: 394,
    viewBox: "0 0 728 394",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M724.915 231.262C723.664 218.396 721.877 205.529 720.09 192.841C712.941 145.127 714.371 82.4018 684.885 41.6573C672.018 23.7868 650.931 20.5702 630.916 16.6387C539.598 -1.76785 443.098 0.197917 350.35 0.019213C294.773 -0.159491 239.375 0.912701 183.977 3.05715C135.727 5.0229 81.5794 1.80624 34.9376 15.0304C-12.2403 28.4332 1.34125 83.474 3.307 120.287C6.52368 183.012 10.6339 245.737 15.4589 308.463C17.4246 334.017 26.1811 386.199 61.0284 386.378C145.913 386.914 232.763 393.526 317.112 389.416C379.122 386.378 441.132 382.804 503.321 382.625C537.99 382.446 710.797 414.97 720.983 366.005C729.74 321.687 729.382 276.117 724.915 231.262Z",
    fill: "#3F2737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreen);
export default __webpack_public_path__ + "static/media/Green.f75958984cb1ba173361cbf81d72a0f8.svg";
export { ForwardRef as ReactComponent };